module.exports = __webpack_public_path__ + "static/android-icon-192x192-3412325b6fdcf4875dc809b7f7ec70d0.png";